<div *ngIf="clases?.length > 0" class="contenedor">
  <!-- Panel de Chat -->
  <div class="userchat fullscreen">
    <!-- Panel de bienvenida -->

    <section class="basicbox chatmessages">
      <!-- Contenedor de mensajes; se usa "
         gesbox" para hacer scroll -->
      <div class="messages" id="themessagesbox" [scrollTop]="scrolltobottom()">
        <div *ngIf="showWelcomePanel" class="welcome-panel">
          <h2>{{ welcomeMessage }}</h2>
          <p>{{ asistentePerfil.descripcion }}</p>

          <div class="quick-suggestions">
            <h4>¿Sobre qué quieres trabajar?</h4>
            <div class="buttons-suggestions">
              <button
                *ngFor="let sugerencia of quickSuggestions"
                (click)="chatmessage = sugerencia"
                (click)="sendMessage()"
              >
                {{ sugerencia }}
              </button>
            </div>
          </div>
        </div>
        <!-- Mensajes enviados -->
        <ng-container *ngFor="let message of chatIa">
          <div
            [ngClass]="{
              'message-right': message?.payload.doc.data().sender === 'openai',
              'message-left': message?.payload.doc.data().sender === mainuserid
            }"
          >
            <!-- Mensaje del usuario -->
            <div
              class="sender"
              *ngIf="message?.payload.doc.data().sender === mainuserid"
            >
              <div class="messagedata-usuario">
                <div class="cabecera">
                  <div class="date-usuario">
                    {{
                      message?.payload.doc.data().fecha.toDate()
                        | date : "dd/MM/y - HH:mm"
                    }}h
                  </div>
                  <div class="name-usuario">
                    {{ usuario?.nombres }} {{ usuario?.apellidos }}
                  </div>
                </div>
                <div class="themessage-usuario">
                  <p>{{ message?.payload.doc.data().message }}</p>
                </div>
              </div>
              <div class="avatar">
                <img
                  *ngIf="usuario?.avatar; else defaultavatar"
                  [src]="usuario?.avatar"
                  alt="Avatar Usuario"
                />
                <ng-template #defaultavatar>
                  <img
                    src="assets/img/defaultavatar.jpg"
                    alt="Avatar por defecto"
                  />
                </ng-template>
              </div>
            </div>
            <!-- Mensaje del asistente -->
            <div
              class="sender"
              *ngIf="message?.payload.doc.data().sender === 'openai'"
            >
              <div class="avatar">
                <img src="assets/img/Botito.png" alt="Avatar por defecto" />
              </div>
              <div class="messagedata-asistente">
                <div class="cabecera">
                  <div class="name-asistente">Asistente&nbsp;</div>
                  <div class="date-asistente">
                    {{
                      message?.payload.doc.data().fecha.toDate()
                        | date : "dd/MM/y - HH:mm"
                    }}h
                  </div>
                </div>
                <div class="themessage-asistente">
                  <!-- Se muestra el mensaje procesado -->
                  <div [innerHTML]="message?.processedMessage"></div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Mensaje en proceso (efecto tipeo) -->
        <div *ngIf="loadingResponse" class="message-right">
          <div class="avatar">
            <img src="assets/img/ROBOTTHECAMPUS.png" alt="Avatar por defecto" />
          </div>
          <div class="messagedata">
            <div class="cabecera">
              <div class="name-asistente">Asistente&nbsp;</div>
              <div class="date-asistente">Ahora</div>
            </div>
            <!-- Spinner de respuesta -->
            <div *ngIf="loadingResponse" class="loading-spinner">
              <i class="fas fa-spinner fa-spin"></i> Procesando respuesta...
            </div>

            <div *ngIf="typingMessage != ''" class="themessage-asistente">
              <div [innerHTML]="formattedTypingMessage"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- Caja de envío de mensaje -->
      <div class="sendbox">
        <div class="input-with-button">
          <input
            class="messagebox"
            type="text"
            placeholder="Pregutame lo que quieras"
            [(ngModel)]="chatmessage"
            (keyup.enter)="sendMessage()"
          />
          <button
            class="send-button"
            (click)="sendMessage()"
            [disabled]="isLoading"
          >
            <ng-container *ngIf="!isLoading; else loadingIcon">
              <i class="fas fa-paper-plane"></i>
            </ng-container>
            <ng-template #loadingIcon>
              <i class="fas fa-spinner fa-spin"></i>
              <!-- Ícono girando -->
            </ng-template>
          </button>
        </div>
      </div>
    </section>
  </div>

  <!-- Panel de Ventanas (Historial) -->
  <div class="ventanas">
    <section class="basicbox ventanasbox">
      <div class="chat-groups">
        <div *ngFor="let clase of clases">
          <h3>{{ clase.datos.nombre }}</h3>

          <!-- Nombre bonito de la clase -->

          <div
            *ngFor="let chat of groupedChatSessions[clase.id]"
            class="chat-title"
          >
            <span (click)="openChatSession(chat)">
              {{ chat.title }}
            </span>
            <button
              (click)="deleteChat(chat.id)"
              class="delete-chat-button"
              title="Borrar chat"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <!-- <-- AQUÍ se cierra bien el div de cada claseId -->
      </div>
    </section>
  </div>
</div>

<!-- Mensaje de aviso cuando no hay chats en el historial -->
<div *ngIf="clases?.length == 0" class="no-chats-message">
  <div class="no-chats-content">
    <h2>No tienes ningún chat en tu historial</h2>
    <h3>Para iniciar un chat, ve al Mentix de la clase</h3>
    <select [(ngModel)]="selectedClaseId">
      <option *ngFor="let clase of clasesUsuario" [value]="clase.id">
        {{ clase.datos.nombre }}
      </option>
    </select>
    <div class="no-chats-actions">
      <button routerLink="/dashboard/iafiles/{{ selectedClaseId }}">
        Ir a clase
      </button>
    </div>
  </div>
</div>

<style></style>
